// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import { PromotionsConnectionFragmentDoc } from '../../../client/components/Promotions/Promotion/graphql/GetPromotionQuery.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoggedInBannerQueryVariables = Types.Exact<{
  filter: Types.ContentPageConnectionFilter;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type LoggedInBannerQuery = { __typename?: 'Query', content?: { __typename?: 'Content', id: string, currentPromotions?: { __typename?: 'ContentPageConnection', edges?: Array<{ __typename?: 'ContentPageEdge', node?: { __typename: 'ContentPage', id: string, name?: string, mainBlock?: string, smallImage?: string, mediumImage?: string, largeImage?: string, bannerButtonText?: string, terms?: string, termsExternal?: string, handle?: string, promotionType?: string, sectionHandle?: string, summary?: string, participating?: boolean, publishEndDate?: string, link?: string, title?: string } }> } } };


export const LoggedInBannerQueryDocument = /*#__PURE__*/ gql`
    query LoggedInBannerQuery($filter: ContentPageConnectionFilter!, $first: Int) {
  content {
    id
    currentPromotions: pages(
      filter: $filter
      first: $first
      sort: {publishDate: -1}
    ) {
      ...PromotionsConnection
    }
  }
}
    ${PromotionsConnectionFragmentDoc}`;
export function useLoggedInBannerQuery(baseOptions: Apollo.QueryHookOptions<LoggedInBannerQuery, LoggedInBannerQueryVariables> & ({ variables: LoggedInBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoggedInBannerQuery, LoggedInBannerQueryVariables>(LoggedInBannerQueryDocument, options);
      }
export function useLoggedInBannerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoggedInBannerQuery, LoggedInBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoggedInBannerQuery, LoggedInBannerQueryVariables>(LoggedInBannerQueryDocument, options);
        }
export function useLoggedInBannerQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoggedInBannerQuery, LoggedInBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoggedInBannerQuery, LoggedInBannerQueryVariables>(LoggedInBannerQueryDocument, options);
        }
export type LoggedInBannerQueryHookResult = ReturnType<typeof useLoggedInBannerQuery>;
export type LoggedInBannerQueryLazyQueryHookResult = ReturnType<typeof useLoggedInBannerQueryLazyQuery>;
export type LoggedInBannerQuerySuspenseQueryHookResult = ReturnType<typeof useLoggedInBannerQuerySuspenseQuery>;
export type LoggedInBannerQueryQueryResult = Apollo.QueryResult<LoggedInBannerQuery, LoggedInBannerQueryVariables>;